import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import type { InputHTMLAttributes } from 'react'

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  error?: boolean
  /** Override the eye-button icon color class. Defaults to text-text-muted hover:text-text-primary */
  iconClassName?: string
}

export function PasswordInput({
  error,
  className = '',
  iconClassName = 'text-text-muted hover:text-text-primary',
  disabled,
  ...props
}: PasswordInputProps) {
  const [show, setShow] = useState(false)

  return (
    <div className="relative">
      <input
        {...props}
        type={show ? 'text' : 'password'}
        disabled={disabled}
        className={`pr-10 text-sm focus:outline-none focus-visible:ring-2 transition-all disabled:opacity-60 w-full ${
          error ? 'border-red-500/50 focus-visible:ring-red-500/40' : ''
        } ${
          className ||
          'bg-background border border-border rounded-md px-3 py-2.5 text-text-primary placeholder:text-text-muted focus-visible:ring-accent/40 focus-visible:ring-offset-2'
        }`}
      />
      <button
        type="button"
        tabIndex={-1}
        disabled={disabled}
        onClick={() => setShow(v => !v)}
        className={`absolute right-3 top-1/2 -translate-y-1/2 transition-colors disabled:opacity-50 ${iconClassName}`}
        aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  )
}
